import React, { useState } from 'react';
import { Stack, Switch, Typography } from '@mui/material';

interface AutoApplicationsActionProps {
  field: string; 
  value: boolean; 
  updateProfile: (data: { [key: string]: boolean }) => void; 
}

const AutoApplicationsAction: React.FC<AutoApplicationsActionProps> = ({
  field,
  value,
  updateProfile,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(value);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    updateProfile({ [field]: checked });
  };

  return (
    <Stack direction="row" spacing={3} alignItems="center" sx={{ mt: 2 }}>
      <Switch onChange={handleSwitchChange} size="medium" checked={isChecked} />
      <Typography sx={{ whiteSpace: 'nowrap' }}>
        {isChecked ? 'ON' : 'OFF'}
      </Typography>
    </Stack>
  );
};

export default AutoApplicationsAction;
